import React, { useContext } from 'react';
import { Context } from '../../../store/store';
import { StyledGoBackToMainMenuButton } from './go-back-to-main-menu-button.styles';

const GoBackToMainMenuButton = () => {
  const [, dispatch] = useContext(Context);
  return (
    <StyledGoBackToMainMenuButton
      onClick={() => dispatch({ type: 'GO_BACK_TO_MAIN_MENU' })}
    >
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 10L14 17.5L21 25"
          stroke="#0F4C81"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </StyledGoBackToMainMenuButton>
  );
};

export default GoBackToMainMenuButton;
